<template>
  <b-sidebar
    shadow
    visible
    backdrop
    no-header
    class="show"
    :id="'transactions-'+order.order_id"
    body-class="cp-sidebar__body"
    sidebar-class="cp-sidebar transactions-sidebar"
    @change="toggleScrollbar()"
  >

    <SidebarHeader :title="'Your Transactions'" @clear="toggleScrollbar" />
    <div class="cp-sidebar__main">
      <ProcessingLoader v-if="processing" />
      <template v-else-if="hasTransactions">
        <div class="cp-sidebar__trans" v-for="(itemTransaction, transactionDate) in transactions" v-bind:key="'transaction-'+transactionDate">
          <div class="cp-sidebar__trans__date">{{transactionDate}}</div>
          <template v-for="(transactionInfo, transId) in itemTransaction">
            <TransactionInfo :transaction="transactionInfo" v-bind:key="'transaction-info-' + transId"/>
            <template v-if="transactionInfo.refund">
              <hr v-bind:key="'transaction-info-refund-hr-' + transId"/>
              <TransactionInfo v-if="transactionInfo.refund" :transaction="transactionInfo.refund" v-bind:key="'transaction-info-refund' + transId"/>
            </template>
            <hr v-if="transactions.length > 1" v-bind:key="'transaction-info-hr-' + transId"/>
          </template>
        </div>
        <hr class="w-100 mt-0 mb-2"/>
        <div class="cp-sidebar__trans__info w-100">
          <b-button class="cp-sidebar__btn no-outline-btn mt-0" variant="primary" @click.stop="toggleScrollbar()">
            Done
          </b-button>
        </div>
      </template>
      <template v-else>
        <div class="centered-block w-100">
          <div class="step-title">No transactions found</div>
        </div>
      </template>
    </div>
  </b-sidebar>
</template>

<script>
import {TranResponseBadgeClass, TranResponseStrings} from '@/constants'
import {
  formatCurrency,
  toggleBodyScrollbar,
  getHumanReadableDate,
  getItemImageUrl,
  setFallbackImageUrl
} from '@/utils'
import axios from 'axios'
import ProcessingLoader from '@/components/ProcessingLoader'
import SidebarHeader from '@/components/Sidebar/SidebarHeader'
import TransactionInfo from '@/components/Order/TransactionInfo.vue'

export default {
  name: 'OrderTransactions',
  components: {TransactionInfo, SidebarHeader, ProcessingLoader},
  props: {
    order: Object
  },
  data: function() {
    return {
      show: false,
      processing: true,
      items: [],
      transactions: {}
    }
  },
  computed: {
    hasTransactions: function() {
      return this.items.some(item => item.transactions && item.transactions.length > 0)
    }
  },
  methods: {
    toggleScrollbar: function() {
      toggleBodyScrollbar()
      this.$emit('clear')
    },
    close: function() {
      this.$bvModal.hide('order-transactions')
      this.$emit('close')
    },
    populateTransactions: function() {
      let transactions = {}

      for (let item of this.items) {
        (item.transactions || []).forEach((transaction) => {
          const transDate = getHumanReadableDate(transaction.created, true)
          if (!transactions[transDate]) {
            transactions[transDate] = {}
          }

          transactions[transDate][transaction.id.toString()] = {
            transaction_id: transaction.transaction_id,
            status: TranResponseStrings[transaction.response_type],
            amount: formatCurrency(transaction.amount, this.order.currency),
            refund: transaction.refund_amount > 0 ? {
              transaction_id: transaction.transaction_id,
              status: 'Refund',
              badgeClass: 'active',
              amount: `-${formatCurrency(transaction.amount, this.order.currency)}`,
              isRefund: true
            } : null,
            badgeClass: TranResponseBadgeClass[transaction.response_type]
          }
        })
      }

      this.transactions = transactions
      this.processing = false
    },
    getItemImageUrl: function(item) {
      return getItemImageUrl(item, 'medium')
    },
    setAltImg: function(event, item) {
      setFallbackImageUrl(event, item, 'medium', true)
    }
  },
  created() {
    toggleBodyScrollbar(true)
    if (this.order) {
      if (Object.values(this.transactions).length === 0) {
        if (!this.hasTransactions) {
          let requests = []
          if (this.order && this.order.items.length) {
            requests = requests.concat(this.order.items.map((item) => axios.get(`/order_items/${item.id}/`)))
          }

          if (requests.length) {
            this.processing = true
            Promise.all(requests).then(response => {
              this.items = response.map((result) => result.data)
              this.populateTransactions()
            }, () => {
              this.processing = false
            })
          } else {
            this.processing = false // not allowed to show transactions, so nothing to do
          }
        } else {
          this.items = this.order.items
          this.populateTransactions()
        }
        return
      }
    }
    this.processing = false
  }
}
</script>

<style scoped>

</style>
